const CTA_URL = 'https://www.linkedin.com/in/vinoth-trevor-skanthavarathan-01b6ba141/';

const LegalHero = () => {
  return (
    <section
      data-testid="legal-hero-section"
      className="legal-hero"
    >
      <div className="legal-content">
        <div className="legal-eyebrow" data-testid="legal-hero-eyebrow">
          <span className="signal-dot"></span>
          Soundboard Matter
        </div>

        <h1 className="legal-h1 mt-8" data-testid="legal-hero-headline">
          Know the matter. Control the process. Stand behind the work.
        </h1>

        <p className="legal-body mt-8" style={{ maxWidth: '60ch' }} data-testid="legal-hero-subhead">
          A private, matter-aware workspace that organizes your files, shows what is missing, connects answers to their sources, and keeps a record of how AI-assisted work was reviewed and approved.
        </p>

        <div className="legal-cta-group mt-10">
          <a
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="legal-hero-cta"
            className="cta-button"
          >
            Start with one workflow
          </a>
          <a
            href="#how-we-think"
            data-testid="legal-hero-secondary"
            className="legal-secondary-link"
          >
            See how we think about this &rarr;
          </a>
        </div>

        <p className="legal-supporting mt-6" data-testid="legal-hero-supporting">
          You do not need to transform your practice. Begin with one matter type and one recurring task that takes too long.
        </p>
      </div>
    </section>
  );
};

export default LegalHero;
